import { browser } from '$app/environment';

if (browser) {
  window.APP_ENV = import.meta.env['VITE_APP_ENV'];
  window.FACEBOOK_ID = import.meta.env['VITE_FACEBOOK_ID'];
  window.GOOGLE_CLIENT_ID = import.meta.env['VITE_GOOGLE_CLIENT_ID'];
  window.GOOGLE_PLACES_API_KEY = import.meta.env['VITE_GOOGLE_PLACES_API_KEY'];
  window.APP_VERSION = import.meta.env['HEROKU_RELEASE_VERSION'];
}
